var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"transparent py-2 px-1"},[(_vm.Cargando)?_c('div',{staticClass:"pa-4"},_vm._l((10),function(i){return _c('v-skeleton-loader',{staticClass:"mx-auto",attrs:{"type":"paragraph"}})}),1):_c('v-textarea',{attrs:{"readonly":"","auto-grow":"","outlined":"","value":_vm.Publicacion.Descripcion}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }